import {fadeInAnimation} from '../../animations/fade-in.animation';
import {PhoneTypeEnum} from '../../enums/phone';
import {PhoneNumberTypeEnum} from '../../interfaces/phone-number/phone-number-type.enum';
import {IPhoneNumber} from '../../interfaces/phone-number/phone-number.interface';
import {GuidService} from '../../services/guid/guid.service';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-phones',
  templateUrl: './phones.component.html',
  styleUrls: ['./phones.component.scss'],
  animations: [fadeInAnimation]
})
export class PhonesComponent implements OnInit, OnChanges {

  form: UntypedFormGroup = new UntypedFormGroup({});

  @Input() phones: IPhoneNumber[] = [];
  @Input() removeClassCardContainerShadow = false;
  @Input() withoutHeader: boolean;
  @Input() limit: number;
  @Input() description = '';

  phoneNumberTypeEnum = PhoneTypeEnum;
  phoneTypes: PhoneTypeEnum[] = [PhoneTypeEnum.CELLULAR, PhoneTypeEnum.FAX, PhoneTypeEnum.LOCAL];

  loadPhones: boolean;
  phoneWithId: IPhoneNumber[] = [];
  constructor(
    private guidService: GuidService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initForm();
  }

  initForm(): void {
    if (!this.phones) this.phones = [];
    if (this.phones.length === 0) this.phones = [{
      areaCode: '123',
      phoneNumber: '4567890',
      ext: '---',
      formId: this.guidService.guid(),
      type: PhoneNumberTypeEnum.CELLULAR
    }];
    this.phoneWithId = this.phones.map(phone => {
      return { ...phone, formId: this.guidService.guid() };
    });
    for (const phone of this.phoneWithId) {
      this.addFormPhone(phone);
    }
    this.loadPhones = true;
  }

  onAddNewPhone(): void {
    const phone: IPhoneNumber = {
      areaCode: '123',
      phoneNumber: '4567890',
      ext: '---',
      formId: this.guidService.guid(),
      type: PhoneNumberTypeEnum.CELLULAR
    };
    this.phoneWithId.push(phone);
    this.addFormPhone(phone);
    this.phonesAreUnique();
  }

  addFormPhone(phone?: IPhoneNumber): void {
    try {
      this.form.addControl(
        phone.formId,
        new UntypedFormGroup({
          formId: new UntypedFormControl(phone?.formId ? phone.formId : this.guidService.guid()),
          areaCode: new UntypedFormControl(phone?.areaCode ? phone.areaCode : '123', [Validators.required, Validators.minLength(3), Validators.maxLength(3)]),
          areaCodePlaceholder: new UntypedFormControl(phone?.areaCode ? phone.areaCode : '123', []),
          phoneNumber: new UntypedFormControl(
            phone?.phoneNumber ? phone.phoneNumber : '4567890',
            [Validators.required, Validators.minLength(7), Validators.maxLength(7)]
          ),
          phoneNumberPlaceholder: new UntypedFormControl(phone?.phoneNumber ? phone.phoneNumber : '4567890', []),
          ext: new UntypedFormControl(phone?.ext ? phone.ext : '---', [Validators.min(0), Validators.maxLength(5)]),
          extPlaceholder: new UntypedFormControl(phone?.ext ? phone.ext : '---', []),
          type: new UntypedFormControl(phone?.type ? phone.type : this.phoneNumberTypeEnum.CELLULAR, [Validators.required]),
          view: new UntypedFormGroup({
            areaCode: new UntypedFormControl(false, []),
            phoneNumber: new UntypedFormControl(false, []),
            ext: new UntypedFormControl(false, [])
          })
        }, [])
      );
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * Delete a phone
   * @param formId
   */
  onDeletePhoneNumber(formId: string): void {
    this.form.removeControl(formId);
    const index = this.phoneWithId.findIndex((phone) => phone.formId === formId);
    if (index !== -1) {
      this.phoneWithId.splice(index, 1);
    }
    this.phonesAreUnique();
  }

  onShowValue(formId: string, field: string, input: HTMLInputElement): void {
    this.form.get(formId).get('view').get(field).setValue(true);
    setTimeout(() => {
      input.focus();
      input.select();
    }, 10);
    this.phonesAreUnique();
  }

  onHideValue(formId: string, field: string, placeholder: string): void {
    if (this.form.get(formId).get(field).value.length === 0) {
      this.form.get(formId).get(field + 'Placeholder').setValue(placeholder);
    } else {
      this.form.get(formId).get(field + 'Placeholder').setValue(this.form.get(formId).get(field).value);
    }
    this.form.get(formId).get('view').get(field).setValue(false);
    this.phonesAreUnique();
  }

  phonesAreUnique(): boolean {
    let count = 0;
    const phones: IPhoneNumber[] = Object.values(this.form.getRawValue());
    for (let i = 0; i < phones.length; i++) {
      const phoneA = phones[i];
      const existsIndex = phones.findIndex(
        phone => phone.formId !== phoneA.formId && phone.areaCode === phoneA.areaCode && phone.phoneNumber === phoneA.phoneNumber && phone.ext === phoneA.ext
      );
      if (existsIndex !== -1 && existsIndex !== i) {
        this.phoneWithId[i].isEqual = true;
        phoneA.isEqual = true;
        count += 1;
      } else {
        this.phoneWithId[i].isEqual = false;
        phoneA.isEqual = false;
      }
    }
    return count <= 0; // return count > 0 ? false : true;
  }

  getRawValue(): IPhoneNumber[] {
    const value: IPhoneNumber[] = Object.values(this.form.getRawValue());
    return value.map(phone => {
      return {
        areaCode: phone.areaCode,
        phoneNumber: phone.phoneNumber,
        ext: phone.ext,
        type: phone.type
      };
    });
  }

  isValid(): boolean {
    try {
      if (!this.form) return false;
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      return this.form.valid && this.phonesAreUnique();
    } catch (e) {
      console.log(e);
    }
  }
}
